import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Tabs, Tab, CssBaseline, Container, AppBar, Grid } from '@mui/material/';
import { Stack, Button } from '@mui/material';
import { Navigate, Link } from "react-router-dom";

export default function MainContent(props) {
    return (<main {...props}>
        {props.children}
    </main>)
}